// Display constants for the Financials page; the figures come from GET /api/admin/financials
// and the ledger from GET /api/admin/financials/ledger

export const GRANULARITIES = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
];

export const SPLIT_TABS = [
  { value: "direct", label: "Direct" },
  { value: "referred", label: "Referred" },
];

// How one activation fee splits, in stacking order. `swatch` names the colour class.
export const SPLIT_PARTS = [
  { key: "qualificationRedemption", label: "Qualification redemption", swatch: "swatchQualification" },
  { key: "pmm", label: "PMM allocation", swatch: "swatchPmm" },
  { key: "liquidityReserve", label: "Liquidity reserve", swatch: "swatchReserve" },
  { key: "referral", label: "Referral commission", swatch: "swatchReferral" },
  { key: "pbNet", label: "PB net contribution", swatch: "swatchNet", strong: true },
];

// Deductions from gross, drawn right to left as a waterfall
export const ALLOCATION_ROWS = [
  { key: "qualificationRedemption", label: "Qualification redemption", swatch: "swatchQualification" },
  { key: "pmm", label: "PMM allocation", swatch: "swatchPmm" },
  { key: "liquidityReserve", label: "Liquidity reserve", swatch: "swatchReserve" },
  { key: "referralCommissions", label: "Referral commissions", swatch: "swatchReferral" },
];

export const METHOD_LABELS = { card: "Card", crypto: "Crypto", total: "Total" };

// Key order is the order options appear in the ledger filters
export const LEDGER_TYPES = {
  activation: "Activation",
  funded: "Funded account",
  qualification: "Qual. redemption",
  withdrawal: "Withdrawal",
  referral: "Referral",
};

export const LEDGER_METHODS = { card: "Card", crypto: "Crypto" };

export const LEDGER_STATUS = {
  successful: { label: "Successful", tone: "success" },
  pending: { label: "Pending", tone: "warning" },
  failed: { label: "Failed", tone: "danger" },
};

export const LEDGER_SOURCES = { direct: "Direct", referral: "Referral" };

export const LEDGER_DAYS = [
  { value: "7", label: "7D" },
  { value: "30", label: "30D" },
  { value: "90", label: "90D" },
  { value: "365", label: "1Y" },
];
